module.exports = __webpack_public_path__ + "static/media/soggiorno_moderno.3687d265.jpg";